export const valtec = {
    primary: {
        light: '#ff5f4e',
        main: '#ed1c24',
        dark: '#b20000',
        contrastText: '#ffffff',
    },
    secondary: {
        light: '#61f3f7',
        main: '#00c0c4',
        dark: '#008f94',
        contrastText: '#0f0f0f',
    },
};
